import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        list: '=',
        sites: '=',
        defaultFilter: '<',
        filter: '=',
        versions: '<'
    },
    template: `
        <div class="table-filters" ng-model="vm.ngModel">
            <form ng-submit="vm.applyFilter()" class="form form-filter">
                <div class="fields">
                    <div class="row row-md">
                        <label class="label">{{ 'occurenceFilter.Name' | translate }}</label>
                        <div class="items"><input ng-model="vm.filter.name" type="text" class="form-control"></div>
                    </div>
                     <div class="row row-md separated">
                        <label class="label">{{ 'occurenceFilter.Version' | translate }}</label>
                        <div class="items">
                            <div
                                ng-dropdown-multiselect=""
                                options="vm.multiFilter.versions.options"
                                selected-model="vm.multiFilter.versions.model"
                                extra-settings="vm.multiFilter.versions.settings"
                                translation-texts="vm.filterTranslations"
                                >
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'filter.Site' | translate }}</label>
                        <div class="items">
                            <div
                                ng-dropdown-multiselect=""
                                options="vm.multiFilter.sites.options"
                                selected-model="vm.multiFilter.sites.model"
                                extra-settings="vm.multiFilter.sites.settings"
                                translation-texts="vm.filterTranslations"
                                >
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'filter.Status' | translate }}</label>
                        <div class="items">
                            <div
                                ng-dropdown-multiselect=""
                                options="vm.multiFilter.statuses.options"
                                selected-model="vm.multiFilter.statuses.model"
                                extra-settings="vm.multiFilter.statuses.settings"
                                >
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'occurrenceFilter.Include finished occurrences' | translate }}</label>
                        <div class="items">
                            <label class="switch01">
                                <input type="checkbox" ng-model="vm.filter.includeFinishedOccurrences">
                                <span></span>
                            </label>
                        </div>
                    </div>
                </div>
                <ul class="actions01">
                    <li><input ng-click="vm.resetFilter()" type="button" class="btn discrete" value="{{ 'filter.Reset' | translate }}"></li>
                    <li><input type="submit" class="btn main" value="{{ 'filter.Filter' | translate }}"></li>
                </ul>
            </form>
        </div>
    `
})
export default class {
    constructor ($translate, lodash, OCCURRENCE_STATUS_ENUM, ROLE_PRIVILEGE_ENUM, SiteService, FilterService) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.OCCURRENCE_STATUS_ENUM = OCCURRENCE_STATUS_ENUM;
        this.ROLE_PRIVILEGE_ENUM = ROLE_PRIVILEGE_ENUM;
        this.SiteService = SiteService;
        this.FilterService = FilterService;
    }

    $onInit () {
        this.filters = false;
        this.initMultiFilter();
        this.filterTranslations = this.FilterService.getTranslations();
    }

    initMultiFilter () {
        const siteOptions = this.sites.map(site => {
            return {
                value: site.id,
                label: site.name
            };
        });
        const siteOptionsSelected = siteOptions.map(site => site);
        const versionOptions = this.versions.map(version => {
            return {
                value: version.id,
                label: version.name
            };
        });

        const versionOptionsSelected = versionOptions.map(version => version);
        const statusOptions = [
            { value: this.OCCURRENCE_STATUS_ENUM.KEYS.PUBLISHED, label: this.OCCURRENCE_STATUS_ENUM.LABELS.PUBLISHED },
            { value: this.OCCURRENCE_STATUS_ENUM.KEYS.UNPUBLISHED, label: this.OCCURRENCE_STATUS_ENUM.LABELS.UNPUBLISHED },
            { value: this.OCCURRENCE_STATUS_ENUM.KEYS.CANCELLED, label: this.OCCURRENCE_STATUS_ENUM.LABELS.CANCELLED }
        ];
        const statusOptionsSelected = [statusOptions[0], statusOptions[1], statusOptions[2]];

        this.multiFilter = {
            statuses: {
                model: statusOptionsSelected,
                options: statusOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: false,
                    showUncheckAll: false,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                }
            },
            sites: {
                model: siteOptionsSelected,
                options: siteOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: true,
                    showUncheckAll: true,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                }
            },
            versions: {
                model: versionOptionsSelected,
                options: versionOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: true,
                    showUncheckAll: true,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                }
            }
        };
        // this is used when filter is reset
        this.defaultMultiFilter = angular.copy(this.multiFilter);
    }

    applyFilter () {
        const siteIds = !this.multiFilter.sites.model.length ? [-1] : this.multiFilter.sites.model.map(site => site.value);
        const statuses = !this.multiFilter.statuses.model.length ? [-1] : this.multiFilter.statuses.model.map(status => status.value);
        const versionIds = !this.multiFilter.versions.model.length ? [-1] : this.multiFilter.versions.model.map(version => version.value);
        this.filter = this.lodash.assign(this.filter, { siteIds }, { statuses }, { versionIds });
        this.list.fetch({ expand: 'courseVersion,site,courseOccurrenceTrainings,sites' }, this.filter);
    }

    resetFilter () {
        this.filter = angular.copy(this.defaultFilter);
        this.multiFilter = angular.copy(this.defaultMultiFilter);
        this.applyFilter();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/edit/occurrence/filter/index.js